import { TextField } from '@mui/material'

export const ResponseCodeField: React.FC<{
  httpStatusCode: number | null | undefined
}> = ({ httpStatusCode }) => {
  if (!httpStatusCode) return null

  return (
    <TextField
      disabled
      fullWidth
      data-testid="test-status-check-integration-response-code"
      InputProps={{ sx: { fontFamily: 'Monaco' } }}
      label="Response Code"
      sx={{ fontFamily: 'Sohne Mono' }}
      value={httpStatusCode}
    />
  )
}
